// extracted by mini-css-extract-plugin
module.exports = {"buttonWrapper":"searchButton_buttonWrapper__GFxUd","button":"searchButton_button__Fb8Za"};